export default function heroSliderFactory(slideElementsList, options = {}) {
  const slidesList = Array.from(slideElementsList);
  let activeSlideIndex = Math.max(
    slidesList.findIndex(slideEl => slideEl.classList.contains('is-active')),
    0,
  );
  let slideshowIntervalId = null;
  const onSlideSwitchedCallback = options.onSlideSwitched || (() => {});

  /**
   * Just iterates over $slidesList, if we reach the end we circle back to
   * the start
   */
  function progressSlide() {
    let nextSlideIndex = activeSlideIndex + 1;

    // If we are at the end, set next index to 0
    if (nextSlideIndex >= slidesList.length) {
      nextSlideIndex = 0;
    }

    switchToSlide(nextSlideIndex);
  }

  /**
   * If the requested index is out of bounds, do nothing
   */
  function switchToSlide(nextSlideIndex) {
    // Do nothing if out of bounds or switching to same index
    const outOfBounds =
      nextSlideIndex >= slidesList.length || nextSlideIndex < 0;
    const switchingToSameSlide = nextSlideIndex === activeSlideIndex;
    if (outOfBounds || switchingToSameSlide) {
      return;
    }

    // Do transition
    slidesList[nextSlideIndex].classList.add('is-active');
    slidesList[activeSlideIndex].classList.remove('is-active');

    // Record to new state
    const previousIndex = activeSlideIndex;
    activeSlideIndex = nextSlideIndex;

    // Call registered listener
    onSlideSwitchedCallback(previousIndex, activeSlideIndex);
  }

  function startSlideshow(progressDelay) {
    if (slideshowIntervalId !== null) {
      return;
    }

    slideshowIntervalId = setInterval(progressSlide, progressDelay);
  }

  function stopSlideshow() {
    clearInterval(slideshowIntervalId);
    slideshowIntervalId = null;
  }

  return {
    progressSlide,
    switchToSlide,
    startSlideshow,
    stopSlideshow,
    getSlideshowIntervalId() {
      return slideshowIntervalId;
    },
    getActiveSlideIndex() {
      return activeSlideIndex;
    },
  };
}
